import type { PartialTranslation } from "./index";

/** Vietnamese — see `../../vi/index.ts` for the terminology notes. */
export const auth: PartialTranslation["auth"] = {
  backToApp: "Quay lại Lyder Talk",
  passwordStrength: {
    label: "Độ mạnh",
    weak: "Yếu",
    fair: "Khá",
    strong: "Mạnh",
    excellent: "Xuất sắc",
  },
  passwordRules: {
    characters: "8+ ký tự",
    number: "có số",
    capital: "có chữ hoa",
  },
  signin: {
    title: "Chào mừng trở lại",
    subtitle: "Đăng nhập để giữ chuỗi ngày của bạn.",
    submit: "Đăng nhập",
    submitting: "Đang đăng nhập…",
    noAccount: "Chưa có tài khoản?",
    createAccount: "Tạo tài khoản",
    emailLabel: "Email",
    emailPlaceholder: "ban@example.com",
    passwordLabel: "Mật khẩu",
    passwordPlaceholder: "Mật khẩu của bạn",
    forgotPassword: "Quên mật khẩu?",
    showPassword: "Hiện mật khẩu",
    hidePassword: "Ẩn mật khẩu",
    errors: {
      invalidCredentials: "Email và mật khẩu không khớp.",
      required: "Nhập email và mật khẩu của bạn.",
      unexpected: "Không thể đăng nhập. Vui lòng thử lại.",
    },
  },
  signup: {
    title: "Tạo tài khoản",
    subtitle: "Bắt đầu luyện nói ngay từ hôm nay.",
    submit: "Tạo tài khoản",
    submitting: "Đang tạo tài khoản…",
    haveAccount: "Đã có tài khoản?",
    signInInstead: "Đăng nhập",
    displayNameLabel: "Tên hiển thị",
    displayNamePlaceholder: "Chúng tôi nên gọi bạn là gì?",
    emailLabel: "Email",
    emailPlaceholder: "ban@example.com",
    passwordLabel: "Mật khẩu",
    passwordPlaceholder: "Ít nhất 8 ký tự",
    acceptTerms: "Tôi đồng ý với Điều khoản sử dụng và Chính sách bảo mật",
    submitDisabledTerms: "Hãy đồng ý với điều khoản để tiếp tục",
    showPassword: "Hiện mật khẩu",
    hidePassword: "Ẩn mật khẩu",
    errors: {
      emailInUse: "Email này đã được dùng để đăng ký.",
      weakPassword: "Hãy dùng ít nhất 8 ký tự.",
      terms: "Vui lòng đồng ý với điều khoản để tiếp tục.",
      unexpected: "Không thể tạo tài khoản. Vui lòng thử lại.",
    },
  },
  forgotPassword: {
    title: "Đặt lại mật khẩu",
    subtitle: "Chúng tôi sẽ gửi cho bạn một liên kết để chọn mật khẩu mới.",
    submit: "Gửi liên kết đặt lại",
    submitting: "Đang gửi…",
    backToSignIn: "Quay lại đăng nhập",
    emailLabel: "Email",
    emailPlaceholder: "ban@example.com",
    sent: "Kiểm tra hộp thư",
    sentDescription: "Nếu email này có tài khoản, liên kết đặt lại đã được gửi đi.",
  },
  resetPassword: {
    title: "Chọn mật khẩu mới",
    submit: "Cập nhật mật khẩu",
    submitting: "Đang cập nhật…",
    passwordLabel: "Mật khẩu mới",
    passwordPlaceholder: "Ít nhất 8 ký tự",
    confirmLabel: "Xác nhận mật khẩu",
    confirmPlaceholder: "Nhập lại mật khẩu mới",
    mismatch: "Hai mật khẩu không khớp.",
    showPassword: "Hiện mật khẩu",
    hidePassword: "Ẩn mật khẩu",
    success: "Đã cập nhật mật khẩu",
    successDescription: "Bạn có thể đăng nhập bằng mật khẩu mới ngay bây giờ.",
  },
  confirmEmail: {
    title: "Xác nhận email",
    description: "Chúng tôi đã gửi liên kết xác nhận tới {{email}}. Mở liên kết để hoàn tất thiết lập tài khoản.",
    resend: "Gửi lại xác nhận",
    resending: "Đang gửi…",
    resent: "Đã gửi xác nhận",
    changeEmail: "Dùng email khác",
  },
  invite: {
    title: "Bạn được mời",
    subtitle: "Tham gia {{groupName}} trên Lyder Talk.",
    accept: "Chấp nhận lời mời",
    decline: "Để sau",
  },
  callback: {
    signingIn: "Đang đăng nhập…",
    failed: "Không thể hoàn tất đăng nhập.",
  },
  modal: {
    toasts: {
      checkEmail: "Kiểm tra email của bạn",
      checkEmailDescription: "Vui lòng xác nhận email để kích hoạt tài khoản.",
      error: "Lỗi",
    },
    required: {
      title: "Đăng nhập để tiếp tục",
      description:
        "Tạo tài khoản miễn phí để lưu lại công việc của bạn và tiếp tục đúng chỗ bạn đang dở.",
      guardDescription:
        "Trang này được lưu vào tài khoản của bạn. Đăng nhập hoặc tạo tài khoản để mở.",
      filterDescription:
        "Đây là những danh sách của riêng bạn. Đăng nhập hoặc tạo tài khoản để xem.",
      signIn: "Đăng nhập",
      signUp: "Tạo tài khoản miễn phí",
      footnote: "Miễn phí để bắt đầu · không cần thẻ",
      formDescription: "Đăng nhập hoặc tạo tài khoản để tiếp tục.",
      benefits: {
        save: "Lưu và mở lại bản ghi âm của bạn",
        feedback: "Nhận phản hồi AI về phần luyện nói",
        progress: "Theo dõi tiến độ qua từng buổi học",
        history: "Giữ lại lịch sử để xem lại bất cứ lúc nào",
      },
      noteTitle: "Đăng nhập để giữ ghi chú của bạn",
      noteDescription:
        "Ghi chú được lưu vào tài khoản của bạn, nên chúng luôn đi cùng từ vựng và các buổi học.",
      generateTitle: "Đăng nhập để tạo chủ đề",
      generateDescription:
        "Câu hỏi và từ vựng được tạo ra sẽ được lưu vào tài khoản của bạn.",
    },
  },
  /**
   * Copy for the shared auth forms in `@lyder-talk/ui` — see the note in
   * `../en/auth.ts`. Register `bạn` throughout; these are the first words a
   * Vietnamese reader meets after choosing to join.
   */
  forms: {
    signin: {
      showPassword: "Hiện mật khẩu",
      hidePassword: "Ẩn mật khẩu",
      title: "Chào mừng trở lại",
      description: "Tiếp tục chuỗi ngày của bạn từ chỗ bạn đang dở.",
      emailLabel: "Địa chỉ email",
      emailPlaceholder: "ban@example.com",
      passwordLabel: "Mật khẩu",
      forgotPassword: "Quên mật khẩu?",
      submitting: "Đang đăng nhập…",
      submit: "Đăng nhập",
      continueWithGoogle: "Tiếp tục với Google",
      newHere: "Mới đến với Lyder Talk?",
      createAccount: "Tạo tài khoản",
      genericError: "Đã xảy ra lỗi. Vui lòng thử lại.",
    },
    signup: {
      showPassword: "Hiện mật khẩu",
      hidePassword: "Ẩn mật khẩu",
      successTitle: "Mọi thứ đã sẵn sàng",
      successDescription: "Bàn học của bạn đã sẵn sàng. Hãy tạo chủ đề đầu tiên.",
      successTitleConfirmEmail: "Xác nhận email của bạn",
      successDescriptionConfirmEmail: "Chúng tôi đã gửi liên kết xác nhận tới",
      steps: [
        "Đăng nhập bằng tài khoản mới",
        "Tạo chủ đề luyện nói đầu tiên",
        "Lưu những từ bạn gặp khi nói",
      ],
      successActionConfirmEmail: "Đến trang đăng nhập",
      successAction: "Bắt đầu học",
      title: "Tạo tài khoản của bạn",
      description: "Miễn phí để bắt đầu. Tiến độ và từ đã lưu luôn theo bạn.",
      displayNameLabel: "Tên hiển thị",
      displayNamePlaceholder: "Chúng tôi nên gọi bạn là gì?",
      emailLabel: "Địa chỉ email",
      passwordLabel: "Mật khẩu",
      confirmPasswordLabel: "Xác nhận mật khẩu",
      matchHint: "Hai mục phải khớp nhau.",
      creating: "Đang tạo tài khoản…",
      submit: "Tạo tài khoản",
      googleLabel: "Đăng ký bằng Google",
      passwordTooShort: "Mật khẩu phải có ít nhất 8 ký tự.",
      passwordsMismatch: "Hai mật khẩu không khớp.",
      unexpectedError: "Đã xảy ra lỗi không mong muốn. Vui lòng thử lại.",
      haveAccount: "Đã có tài khoản?",
      signInInstead: "Đăng nhập",
    },
    forgot: {
      title: "Đặt lại mật khẩu",
      description: "Nhập email của bạn và chúng tôi sẽ gửi một liên kết để chọn mật khẩu mới.",
      emailLabel: "Địa chỉ email",
      sending: "Đang gửi liên kết…",
      submit: "Gửi liên kết đặt lại",
      backToSignIn: "Quay lại đăng nhập",
      sentTitle: "Kiểm tra hộp thư",
      sentDescription: "Nếu email này có tài khoản, liên kết đặt lại sẽ đến sớm — và hết hạn sau một giờ.",
      tryAnotherEmail: "Thử email khác",
      sendFailed: "Không thể gửi email đặt lại mật khẩu. Vui lòng thử lại.",
    },
    reset: {
      showPassword: "Hiện mật khẩu",
      hidePassword: "Ẩn mật khẩu",
      title: "Tạo mật khẩu mới",
      description: "Hãy chọn một mật khẩu bạn nhớ được nhưng không ai đoán ra.",
      passwordLabel: "Mật khẩu mới",
      confirmPasswordLabel: "Xác nhận mật khẩu mới",
      matchHint: "Hai mục phải khớp nhau.",
      submit: "Đặt lại mật khẩu",
      submitting: "Đang cập nhật mật khẩu…",
      backToSignIn: "Quay lại đăng nhập",
      tooShort: "Mật khẩu phải có ít nhất 8 ký tự.",
      passwordsMismatch: "Hai mật khẩu không khớp.",
      failed: "Không thể đặt lại mật khẩu. Vui lòng thử lại.",
      successTitle: "Đã cập nhật mật khẩu",
      successDescription: "Mật khẩu đã được đặt lại. Hãy đăng nhập bằng mật khẩu mới.",
      missingToken: "Liên kết đặt lại mật khẩu này thiếu mã xác thực. Hãy yêu cầu một liên kết mới bên dưới.",
    },
    showcase: {
      eyebrow: "Lyder Talk",
      headlineLineOne: "Học một ngôn ngữ qua",
      headlineLineTwo: " cách nói thật",
      description:
        "Mười phút tập trung mỗi ngày. Những cuộc trò chuyện thật, bằng chính lời bạn, và một bản ghi chép bạn đã đi được bao xa.",
      benefits: [
        "Gia sư AI nhớ trình độ của bạn",
        "Phát âm tự nhiên trong mọi câu trả lời",
        "Chủ đề được viết mới xoay quanh điều bạn đang học",
        "Độ chính xác và chuỗi ngày, theo dõi từng tuần",
      ],
    },
    legal: {
      termsPrefix: "Bằng việc tiếp tục, bạn đồng ý với",
      termsLink: "Điều khoản",
      andPrefix: "và",
      privacyLink: "Chính sách bảo mật",
      orContinueWith: "hoặc tiếp tục với",
    },
    toasts: {
      welcomeBack: "Chào mừng trở lại!",
      welcome: "Chào mừng!",
      error: "Lỗi",
      accountExists: "Tài khoản đã tồn tại",
      accountExistsDescription: "Bạn đã có tài khoản! Vui lòng đăng nhập.",
      googleFailed: "Không thể đăng nhập bằng Google",
    },
  },
};
